"use strict";
'use es6';

(function () {
  for (let i = 0; i < window.__hsRoot.globals.length; i++) {
    window.__hsRoot.restoreGlobal(window.__hsRoot.globals[i]);
  }
})();

